import ModuleMultiColumnVideos from './ModuleMultiColumnVideos';

export default ModuleMultiColumnVideos;
export * from './ModuleMultiColumnVideos';
